export enum CountryEN {
    POLAND = "Poland",
    SPAIN = "Spain"
}
export enum CountryEN {
    POLAND = "Poland",
    SPAIN = "Spain"
}
